<div id="main-container" class="container" style="overflow: hidden;">
  <div class="row pt-3">
    <div id="Nav1" class="col-md-12">
      <div class="row p-0">
        <div class="col-md-11 col-10 mb-2 pb-2">
          <mat-dialog-content class="mat-typography row m-1 p-1">
            <h2
              class="text-justify text-center mx-auto"
              style="font-weight: bold;"
            >
              <b>TÉRMINOS Y CONDICIONES PARA USO DE CANALES DIGITALES</b>
              <br />
              <br />
            </h2>

            <p class="text-justify ml-2" style="text-align: justify;">
              Hemos actualizado los términos y condiciones, al aceptarlos te
              permitirán realizar transacciones y modificaciones a tu(s)
              pólizas(s) en línea sin tener que ir a una sucursal.<br /><br />
              En caso contrario, quedarás imposibilitado para operar a través de
              los canales digitales.
            </p>
          </mat-dialog-content>

          <mat-dialog-content class="mat-typography">
            <!-- VIEW PDF -->
            <div class="col-md-12  m-1 p-0">
              <mat-accordion (click)="OpenDoc(panelOpenState)">
                <mat-expansion-panel
                  style="max-height: 250px; overflow: auto;"
                  id="ExpansionPanel"
                  (opened)="panelOpenState = true"
                  (closed)="panelOpenState = false"
                >
                  <mat-expansion-panel-header class="col-md-12 col">
                    <mat-panel-title
                      style="color:rgb(35, 33, 114); font-size: medium;"
                    >
                      <b class="text-justify"
                        ><u id="text-content-pdf"
                          >VER TÉRMINOS Y CONDICIONES PARA USO DE CANALES
                          DIGITALES</u
                        ></b
                      >
                    </mat-panel-title>
                  </mat-expansion-panel-header>

                  <div class="row p-1 m-0" style="overflow-y: visible;">
                    <pdf-viewer
                      style="overflow-y: visible;"
                      class="col-lg-12 col-md-12 col-xs-12 col-12 p-0 m-0"
                      #pdfViewer
                      [src]="storageUrl"
                      [original-size]="false"
                    ></pdf-viewer>
                  </div>
                </mat-expansion-panel>
              </mat-accordion>
            </div>
          </mat-dialog-content>

          <!-- DIALOG CONTENT -->
          <mat-dialog-content class="mat-typography row m-1 p-1">
            <p class="text-justify ml-2 my-3" style="text-align: justify;">
              Ingresa tu correo para recibir una copia del presente documento.
              Este mail también será utilizado para futuras comunicaciones
              asociadas a tu(s) seguros(s).
            </p>

            <mat-form-field appearance="outline">
              <input
                #emailInput
                matInput
                placeholder="ingrese@sucrorreo.cl"
                [formControl]="EmailControl"
              />
              <mat-label>Correo Electrónico</mat-label>
              <mat-icon matSuffix>mail</mat-icon>
              <mat-error *ngIf="this.EmailControl.hasError('email')">
                Por Favor ingrese email válido
              </mat-error>
              <mat-error *ngIf="this.EmailControl.hasError('required')">
                Email es <strong>requerido</strong>
              </mat-error>
            </mat-form-field>
          </mat-dialog-content>

          <div class="row  mb-4">
            <div class="col">
              <mat-dialog-actions class="d-flex justify-content-center">
                <ds-button
                  class="mb-1 mt-1 ml-2"
                  variant="dangerOutlined"
                  slot-name="text2"
                  (click)="NAV(0)"
                  [disabled]="this.loading"
                >
                  <span slot="text2">No acepto</span> </ds-button
                ><span style="display:inline-block; width:20px;"></span>
                <ds-button
                  class="mt-1 mb-1 mr-3"
                  variant="primary"
                  slot-name="text2"
                  (click)="NAV(1)"
                  [disabled]="this.EmailControl.hasError('email') || this.EmailControl.hasError('required') || this.loading || this.EmailControl.hasError('pattern')"
                >
                  <span slot="text2">Sí, acepto</span>
                </ds-button>
              </mat-dialog-actions>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="Nav2" class="col-md-12 mt-1 mb-1 p-1" style="display:none;">
      <mat-dialog-content class="mat-typography row m-1 p-1">
        <!-- <h4  class="text-justify text-center mx-auto">TÉRMINOS Y CONDICIONES PARA USO DE CANALES DIGITALES</h4> -->
        <h4 class="text-justify ml-2 mr-2" style="text-align: justify;">
          ¿Estás seguro que rechazas realizar transacciones y modificaciones a
          distancia?
        </h4>
      </mat-dialog-content>

      <mat-dialog-actions class="mb-1" align="center">
        <ds-button
          class="my-1"
          variant="dangerOutlined"
          slot-name="text2"
          (click)="NAV(2)"
        >
          <span slot="text2">Sí, estoy seguro</span>
        </ds-button>
        <span style="display:inline-block; width:20px;"></span>
        <ds-button
          class="my-1"
          variant="primary"
          slot-name="text2"
          (click)="NAV(3)"
        >
          <span slot="text2">Volver</span>
        </ds-button>
      </mat-dialog-actions>
    </div>

    <div id="Nav3" style="display:none;" class="col-md-12 mt-1 mb-1 p-1">
      <mat-dialog-content
        class="mat-typography row m-1 p-1"
        style="text-align:center;"
      >
        <!-- <h2 class="text-justify text-center mx-auto">¡MUCHAS GRACIAS!</h2> -->
        <p class="text-justify ml-2 mr-2" style="text-align: justify;">
          Los <strong>términos y condiciones para uso de canales digitales</strong> han sido
          aceptados con éxito. Hemos enviado a tu correo
          <strong>{{ EmailInput }}</strong> un comprobante de esta aceptación.
        </p>
      </mat-dialog-content>
      <div class="row mb-4">
        <div class="col">
          <mat-dialog-actions class="d-flex justify-content-center">
            <ds-button
              variant="primary"
              slot-name="text2"
              (click)="closePopup()"
              style="text-align:-moz-center; text-align:-webkit-center;"
              class="mb-4"
            >
              <span slot="text2">Aceptar</span>
            </ds-button>
          </mat-dialog-actions>
        </div>
      </div>
    </div>
  </div>
</div>
